import React from 'react';
import { motion } from 'framer-motion';
import { MessageCircleIcon, HammerIcon, PaintbrushIcon, MaximizeIcon, WrenchIcon } from 'lucide-react';
import { WA_URL } from './constants';
const services = [{
  icon: HammerIcon,
  title: 'Construcción y obras generales',
  description: 'Trabajos de construcción para proyectos habitacionales, comerciales o mejoras estructurales.'
}, {
  icon: PaintbrushIcon,
  title: 'Remodelaciones',
  description: 'Renovación de espacios interiores o exteriores para mejorar funcionalidad, estética y valor.'
}, {
  icon: MaximizeIcon,
  title: 'Ampliaciones',
  description: 'Soluciones para ampliar espacios y adaptar tu propiedad a nuevas necesidades.'
}, {
  icon: WrenchIcon,
  title: 'Terminaciones y mejoras',
  description: 'Detalles finales, reparaciones y mejoras para dejar tus espacios listos y funcionales.'
}];
export function Services() {
  return <section className="py-20 bg-concrete" data-id="element-131">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-132">
        <div className="text-center mb-16" data-id="element-133">
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="text-3xl md:text-4xl font-bold text-navy" data-id="element-134">
            Servicios de construcción
          </motion.h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-135">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-136">
              <div className="flex items-start gap-4 mb-4" data-id="element-137">
                <div className="w-12 h-12 bg-orange/10 rounded-xl flex items-center justify-center text-orange shrink-0" data-id="element-138">
                  <service.icon className="w-6 h-6" data-id="element-139" />
                </div>
                <div data-id="element-140">
                  <h3 className="text-xl font-bold text-navy mb-2" data-id="element-141">
                    {service.title}
                  </h3>
                  <p className="text-gray-600" data-id="element-142">{service.description}</p>
                </div>
              </div>
              <div className="mt-auto pt-6" data-id="element-143">
                <a href={WA_URL} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 text-orange font-semibold hover:text-orange-hover transition-colors" data-id="element-144">
                  <MessageCircleIcon className="w-5 h-5" data-id="element-145" />
                  Consultar por WhatsApp
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}